export default __webpack_public_path__ + "static/arrow-left-b9cbe885430336e629e11c1d30b4d1bf.png";